module.exports = __webpack_public_path__ + "img/asesoria.d82c5adf.svg";